import { Loader2 } from 'lucide-react';

/** Shown while lazy route chunks load (code-splitting). */
export function PageLoadingFallback() {
  return (
    <div
      className="flex min-h-[50vh] w-full flex-col items-center justify-center gap-3 bg-background px-4"
      role="status"
      aria-live="polite"
    >
      <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden />
      <span className="sr-only">Memuat halaman</span>
    </div>
  );
}
